import { object, string, type InferType } from 'yup'

export const LeadSchema = object({
	email: string().email('Invalid email').required('Required'),
	first_name: string().required('Required'),
	company_name: string().required('Required'),
	type: string().required('Required')
})

export type LeadSchemaT = InferType<typeof LeadSchema>

export const NewLeadEndpoint = 'https://n8n.juicyllama.com/webhook/www/leads'
